import { Component, Input } from '@angular/core';
import * as _ from 'lodash';

import { FrontendSearchWidgetComponent } from 'shared/search-widget/frontend-search-widget.component';

import { columns } from './columns';


@Component({
  moduleId: module.id,
  selector: 'export-downloads-table',
  templateUrl: 'export-downloads-table.component.html',
  styleUrls: ['export-downloads-table.component.scss'],
})
export class ExportDownloadsTableComponent extends FrontendSearchWidgetComponent {

  @Input() declare data: any[];

  columns: any = columns;
  sortingColumns: any = [];
  searchFilterField: string = 'receiver_name';
  ghostValue: string = 'receiver-search';

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get isEmpty() {
    return !this.data || !this.data.length;
  }

  get searchResultsHeight(): string {
    if (!this.searchResultsData || !this.searchResultsData.length) { return '154px'; }
    const rowsHeight = this.searchResultsData.length * 81 + 2;
    return rowsHeight > 550 ? '550px' : `${rowsHeight}px`;
  }
}
